import React, { lazy, Suspense, useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import useNews from "../hooks/useNews";
import usePgiModules from "../hooks/useModules";
import CarouselMobile from "../components/carousel/CarouselMobile";
import ModuleBlockNews from "../components/news/ModuleBlockNews";
import { Helmet, HelmetProvider } from "react-helmet-async";
import toast from "react-hot-toast";
import Pagination from 'react-bootstrap/Pagination';
import { allCategories } from "../helpers/constants";
import useProduct from "../hooks/useProduct";
import { PRODUCTO_ESPECIAL, PRODUCTO_LINEA } from "../helpers/constants";
import { sortAndFilterProducts } from "../helpers/functions";

const NavTensoNews = lazy(() => import("../components/nav/NavTensoNews"));
const CardNews = lazy(() => import("../components/news/CardNews"));
const CardVideo = lazy(() => import("../components/news/CardVideo"));
const GrandCardBlog = lazy(() => import("../components/news/GrandCardBlog"));
const SliderNews = lazy(() => import("../pages/SliderNews"));
const BannerPub = lazy(() => import("../components/BannerPub"));

const TensoBlog = () => {
  const { getAllProducts, products } = useProduct();
  const { obtenerVideos, obtenerNoticias } = useNews();
  const [homeModules, setHomeModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getModulesByParams } = usePgiModules();
  const [currentPage, setCurrentPage] = useState(1);
  const [newsPerPage, setNewsPerPage] = useState(12);
  const [category, setCategory] = useState(allCategories);
  const [lastPage, setLastPage] = useState(1);
  const [allCategoriesNews, setAllCategoriesNews] = useState([]);
  const [news, setNews] = useState([]);
  const [newsVideo, setNewsVideo] = useState([]);

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setHomeModules(res.sort((a, b) => a.position - b.position));
    });
    getAllProducts({ onlyTitleAndIcon: true, visible: true });
  }, []);

  useEffect(() => {
    const getNewsInfo = async () => {
      setLoading(true);
      try {
        const data = await obtenerNoticias(currentPage, newsPerPage, category);
        const dataVideo = await obtenerVideos();
        setNewsVideo(dataVideo.allNews);
        setNews(data.allNews);
        setLastPage(data.lastPage);
        setAllCategoriesNews(data.allCategories);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error('Error al obtener todas las noticias');
      }
    }
    getNewsInfo();

  }, [currentPage, newsPerPage, category])

  const handleChange = (event) => {
    const selected = event.target.defaultValue;
    setCategory(selected);
    setCurrentPage(1);
  };
  const handleChangeSelect = (event) => {
    const selected = event.target.value;
    setCategory(selected);
    setCurrentPage(1);
  };

  const newsGrandCard = news?.filter(
    (noticia) =>
      noticia?.deleted === false &&
      noticia?.visible === true &&
      noticia?.publish === true
  );

  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url != "undefined") {
        window.open(url, "_blank");
      }
    };
    callback("event", "conversion", {
      send_to: "AW-936555276/n6xiCLOq4bYBEIzmyr4D",
    });
    return false;
  }

  const getPageNumbers = () => {
    return Array.from({ length: lastPage }, (_, index) => index + 1).map((page) => (
      <Pagination.Item
        key={page}
        active={page === currentPage}
        onClick={() => setCurrentPage(page)}
      >
        {page}
      </Pagination.Item>
    ));
  };

  return (
    <>
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>Artículos Informativos sobre Ingeniería y Tecnología del hormigón</title>
          <meta name="title" content="Artículos Informativos sobre Ingeniería y Tecnología del hormigón"/>
          <meta name="description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />

          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content="https://tensolite.com/tensonews"
          />
          <meta property="og:title" content="Artículos Informativos sobre Ingeniería y Tecnología del hormigón" />
          <meta property="og:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="og:image" content="https://tensolite.com/images/redes.png" />
          
          <meta property="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:url"
            content="https://tensolite.com/tensonews"
          />
          <meta property="twitter:title" content="Artículos Informativos sobre Ingeniería y Tecnología del hormigón" />
          <meta property="twitter:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="twitter:image" content="https://tensolite.com/images/redes.png" />
        </Helmet>
      </HelmetProvider>
      <Suspense fallback={<div> </div>}>
        <NavTensoNews />
        {/* Carousel */}

        <section>
          <SliderNews />
        </section>

        {/* NOTICIAS */}
        <div className="container">
          <section id="seccion-noticias-videos-blog">
            <div className="seccion-noticias">
              {loading ? (
                <>
                  <GrandCardBlog loading={loading} />
                  <GrandCardBlog loading={loading} />
                  <GrandCardBlog loading={loading} />
                </>
              ) : (
                newsGrandCard
                  .slice(0, 3)
                  .map(
                    (noticia, index) =>
                      noticia.deleted === false &&
                      noticia.visible === true &&
                      noticia.publish === true && (
                        <GrandCardBlog
                          loading={loading}
                          key={index}
                          noticia={noticia}
                        />
                      )
                  )
              )}
            </div>
            {/* Ultimos videos y cuadrante de suscripcion */}

            <div className="seccion-videos inRight">
              <div className="text-video">
                <div className="titulo-seccion-video noticias-hr">
                  <p className="titulo-roboto">Últimos videos</p>
                </div>
                <div className="video-destacado">
                  <div id="videos-recomendados">
                    {loading ? (
                      <>
                        <CardVideo loading={loading} />
                        <CardVideo loading={loading} />
                        <CardVideo loading={loading} />
                      </>
                    ) : (
                      <>
                        {newsVideo
                          .slice(0, 3)
                          .map(
                            (noticia, index) =>
                              noticia.deleted === false &&
                              noticia.visible === true &&
                              noticia.publish === true && (
                                <CardVideo
                                  loading={loading}
                                  key={index}
                                  noticia={noticia}
                                />
                              )
                          )}
                      </>
                    )}
                  </div>
                </div>
                <div className="cuadrante-suscripcion">
                  <div>
                    <h5>Newsletter</h5>
                    <p>
                      Recibí información especializada de la industria de la
                      construcción y de Tensolite: Videos instructivos,
                      novedades del sector, grandes ofertas, y mucho más.
                    </p>
                  </div>
                  <div className="d-flex justify-content-center">
                    <button className="settings_button-pleno bg-p-secondary my-2 d-flex justify-content-center button-footer">
                      <a
                        onClick={() =>
                          gtag_report_conversion(
                            "https://mailchi.mp/tensolite/newsletters"
                          )
                        }
                        target="__blank"
                        rel="noopener"
                        href="https://mailchi.mp/tensolite/newsletters"
                      >
                        SUSCRIBIRSE
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Modulos de publicidad */}
          {homeModules.map((item, index) => {
            switch (item.title) {
              case "Banner_publicitario":
                if (item.visible.includes("news")) {
                  return (
                    <BannerPub
                      key={index}
                      className="w-100"
                      idProducto={"news"}
                    />
                  );
                }
                break;
              case "Bloque_info":
                if (item.visible.includes("home")) {
                  return <ModuleBlockNews key={index} idProducto={"news"} />;
                }
                break;
              default:
            }
          })}
          {homeModules.map((item, index) => {
            switch (item.title) {
              case "Carrousel_deLinea":
                if (item.visible.includes("news")) {
                  return (
                    <div key={index} className="producto-linea">
                      <CarouselMobile isTensoBlogPage products={sortAndFilterProducts(products, PRODUCTO_LINEA)}/>
                    </div>
                  );
                }
                break;
              case "Carrousel_especial":
                if (item.visible.includes("news")) {
                  return (
                    <div key={index} className="producto-linea">
                      <CarouselMobile isTensoBlogPage isProductoEspecial products={sortAndFilterProducts(products, PRODUCTO_ESPECIAL)}/>
                    </div>
                  );
                }
                break;
              default:
            }
          })}

          {/* Card Noticias */}

          <section className="container in">
            <div className="title-noticias ">
              <h3>Más noticias</h3>
              <div className="select-none mt-2 mb-3 d-flex flex-wrap">
                <div className="d-flex align-items-center">
                  <p className="mt-2 me-3 font-filter">Filtrar por: </p>
                  <select
                    className="category-select me-3"
                    name="category_news"
                    onChange={handleChangeSelect}
                  >
                    <option selected value='all'>Todos</option>
                    {allCategoriesNews?.map(
                      (categoria, index) =>
                        categoria.length > 0 && (
                          <option key={index} value={categoria}>
                            {categoria}
                          </option>
                        )
                    )}
                  </select>
                </div>
                <div className="d-flex align-items-center">
                  <p className="mt-2 me-3 font-filter">Mostrar: </p>
                  <select className="category-select-quantity" name="pagination" onChange={(e) => setNewsPerPage(e.target.value)}>
                    <option value="10">12</option>
                    <option value="20">24</option>
                    <option value="30">36</option>
                  </select>
                </div>
              </div>
              <FormControl className="category-check">
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  defaultValue="all"
                >
                  <FormControlLabel
                    value="all"
                    control={<Radio />}
                    label="Todos"
                    onChange={handleChange}
                  />
                  {allCategoriesNews?.map(
                    (categoria, index) =>
                      categoria && (
                        <FormControlLabel
                          id={index}
                          value={categoria}
                          control={<Radio />}
                          label={categoria}
                          onChange={handleChange}
                        />
                      )
                  )}
                </RadioGroup>
              </FormControl>
            </div>
            <div className="slide-Tenso-News">
              <div className="slide-Tenso-detail">
                {loading ? (
                  <>
                    <CardNews loading={true} tensoblog={true} />
                    <CardNews loading={true} tensoblog={true} />
                    <CardNews loading={true} tensoblog={true} />
                    <CardNews loading={true} tensoblog={true} />
                  </>
                ) : (
                  <>
                    {news?.map(
                      (noticia, index) => (
                          <CardNews
                            key={index}
                            noticia={noticia}
                            tensoblog={true}
                            loading={loading}
                            tensoblogClass={true}
                          />
                        )
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="container d-flex justify-content-center mb-4">
              <Pagination>
                <Pagination.Prev className="p-0" onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1} />
                {getPageNumbers()}
                <Pagination.Next className="p-0" onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === lastPage} />
              </Pagination>
            </div>
          </section>
        </div>
      </Suspense>
    </>
  );
};
export default TensoBlog;
